import { useTypeSelector } from '../useTypeSelector';

export const useNetwork = () => {
  return useTypeSelector((state) => state.network);
};
